import { AuthModule } from './auth/auth.module';
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { ApplicationRef, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { JwtHelper } from 'angular2-jwt';
import { TextMaskModule } from 'angular2-text-mask';
import { HeaderInterceptor } from './header-interceptor';
import { ResponseInterceptor } from './request-interceptor';
import { SmartadminInputModule } from './shared/forms/input/smartadmin-input.module';
import { SmartadminValidationModule } from './shared/forms/validation/smartadmin-validation.module';
import { ModalSessaoComponent } from './shared/layout/modal-sessao/modal-sessao.component';
import { SmartadminModule } from './shared/smartadmin.module';
import { StatsModule } from './shared/stats/stats.module';
import { SmartadminDatatableModule } from './shared/ui/datatable/smartadmin-datatable.module';
import { SmartadminWidgetsModule } from './shared/widgets/smartadmin-widgets.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SharedModule } from './shared/shared.module';

import { AuthService } from './_services/auth.service';
import { AppComponent } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { routing } from './app.routing';
import { AppState, InternalStateType } from './app.service';
import { CoreModule } from './core/core.module';
import { MultiselectDropdownModule } from './shared/custom/angular-2-dropdown-multiselect/src/multiselect-dropdown';
import { SmartadminLayoutModule } from './shared/layout/layout.module';
import { LoaderModule } from './shared/loader/loader.module';
import { AtualizaSenhaComponent } from './auth/atualiza-senha/atualiza-senha.component';
import { AuthGuard } from './_guards/auth.guard';
import { UserClaimGuard } from './_services/user-claim-guard.service';
import { GoogleTagManagerService } from './_services/google-tag-manager.service';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ApplicationInsightsModule, AppInsightsService } from '@markpieszak/ng-application-insights';
import { RouterModule } from '@angular/router';
import { environment } from 'environments/environment';
import { CustomGuard } from './app.guard';
import { SncPrivacyNoticeService } from './shared/custom/snc-privacy-notice/snc-privacy-notice.service';

registerLocaleData(localePt, 'pt');

const APP_PROVIDERS = [
  ...APP_RESOLVER_PROVIDERS,
  AppState,
  AuthService,
  AuthGuard,
  UserClaimGuard,
  JwtHelper
];

type StoreType = {
  state: InternalStateType,
  restoreInputValues: () => void,
  disposeOldHosts: () => void
};

@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
    ModalSessaoComponent,
    AtualizaSenhaComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    CoreModule,
    SmartadminLayoutModule,
    routing,
    LoaderModule,
    HttpClientModule,
    SmartadminLayoutModule,
    SmartadminModule,
    SmartadminInputModule,
    SmartadminValidationModule,
    StatsModule,
    SmartadminDatatableModule,
    SmartadminWidgetsModule,
    MultiselectDropdownModule,
    TextMaskModule,
    AuthModule,
    NgMultiSelectDropDownModule.forRoot(),
    ApplicationInsightsModule.forRoot({
      instrumentationKey: environment.appInsights.instrumentationKey
    }),
    SharedModule
  ],
  exports: [
  ],
  providers: [
    APP_PROVIDERS,
    ResponseInterceptor,
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'pt' },
    AppInsightsService,
    CustomGuard,
    { provide: 'googleTagManagerId', useValue: 'GTM-K92648D' },
    GoogleTagManagerService,
    SncPrivacyNoticeService
  ]
})
export class AppModule {
  constructor(
    public appRef: ApplicationRef,
    public appState: AppState
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts